<div class="td-wb-checkbox td-wb-checkbox--toggle"
     [class.td-wb-toggle--small]="small()">
  <input type="checkbox"
         class="td-wb-checkbox__input"
         [attr.id]="finalToggleId()"
         [attr.role]="'switch'"
         [name]="finalName()"
         [attr.value]="optionValue()"
         [attr.tabindex]="tabIndex()"
         [disabled]="disabled()"
         [readonly]="readonly()"
         [attr.aria-label]="ariaLabel()"
         [attr.aria-labelledby]="ariaLabelledBy()"
         [attr.aria-describedby]="ariaDescribedBy()"
         [checked]="checked()"
         (change)="onChange($event)"
         (click)="onInputClick($event)">
  <label class="td-wb-checkbox__label"
         [attr.for]="finalToggleId()"
         [attr.aria-hidden]="hasAriaLabel() ? 'true' : null">
    <span class="td-wb-checkbox__label-content">
      <ng-content />
    </span>
  </label>
</div>



